import QueryString from 'qs';
import initAxiosInterceptor from '@/utils/axios-interceptor';

const useAxios = () => {
  let axios = require('axios');

  const axiosConfig = {
    timeout: 30000,
    paramsSerializer: function (params) {
      return QueryString.stringify(params, {arrayFormat: 'repeat', allowDots: true});
    }
  };

  axios = axios.create(axiosConfig);
  initAxiosInterceptor(axios);

  return axios;
}

const AxiosPlugin = {
  install: (app) => {
    let instance = useAxios();
    app.config.globalProperties.$axios = instance;
    app.provide('$axios', instance);
  }
}

export default AxiosPlugin;
export {useAxios, AxiosPlugin};
